import { currencyFormatter } from './currencyFormatter.js';

/**
 * Sets the subtotal price of all items in the table.
 *
 * @param {Order} order - The order object structure containing the subitems and subitem prices.
 * @param {boolean} applyFee - Whether the additional fees should be applied.
 */
export function setSubTotalPrices(order, applyFee = false) {
  order.subitem_prices.forEach(subitemPrice => {
    const { ticket_bucket, variant } = subitemPrice.subitem;

    // get variant id if set or ticket_bucket
    const bucketId = variant ? variant : ticket_bucket;

    // get table cell with id subtotal-${bucketId}
    const subItemTotalCell = document.getElementById(`subtotal-${bucketId}`);
    if (!subItemTotalCell) return; // Make sure the cell exists

    let finalSubTotal = subitemPrice.total || 0;
    if (applyFee) {
      finalSubTotal += (finalSubTotal * 0.0249) + 0.35; // 2.49% + 0.35 EUR Gebühr
    }

    // Set Total to the table cell
    subItemTotalCell.innerHTML = `<span>${currencyFormatter(finalSubTotal / 100)}</span>`;
  });
}
